exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideMode-Dashboard[data-v-787963a7]{display:flex!important}.icon[data-v-787963a7]{transform:scale(.8);margin-top:4px}", ""]);

// exports
